module.exports = __webpack_public_path__ + "static/media/ruzencova-historie-vyrez.56258d6f.jpg";